// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"fc6f1dcc","419":"6269b543"}[chunkId] + ".chunk.js";
};